import SpriteSymbol from "../../../../mobile/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-person",
  "use": "svg-icon-person-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg-icon-person\"><path d=\"M6,7 C7.66875,7 11,7.5625 11,9.75 L11,9.75 L11,10.375 C11,10.720178 10.720178,11 10.375,11 L10.375,11 L1.625,11 C1.27982203,11 1,10.720178 1,10.375 L1,10.375 L1,9.75 C1,7.5625 4.33125,7 6,7 Z M6,1 C7.38125,1 8.5,2.11875 8.5,3.5 C8.5,4.88125 7.38125,6 6,6 C4.61875,6 3.5,4.88125 3.5,3.5 C3.5,2.11875 4.61875,1 6,1 Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol